import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { Plus, Settings, Check } from 'lucide-react';

const ProfileSelect = () => {
  const { profiles, setProfile } = useApp();
  const nav = useNavigate();
  const [editing, setEditing] = useState(false);

  const pick = (p) => { setProfile(p); nav('/'); };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center relative">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -left-40 w-[560px] h-[560px] rounded-full bg-[#E50914]/15 blur-[140px]" />
        <div className="absolute -bottom-40 -right-20 w-[520px] h-[520px] rounded-full bg-white/5 blur-[140px]" />
      </div>
      <div className="relative">
        <div className="flex items-center justify-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-[#E50914] flex items-center justify-center">
            <span className="font-display text-2xl text-white leading-none">B</span>
          </div>
          <div className="font-display text-2xl tracking-wider text-white">BLUNT TV</div>
        </div>
        <h1 className="font-display text-5xl md:text-7xl text-white text-center tracking-wider mt-4">Who's Watching?</h1>
        <p className="text-white/55 text-center mt-3">Select a profile to continue. Tap the gear to set Kids mode.</p>

        <div className="mt-14 flex gap-8 flex-wrap justify-center">
          {profiles.map((p) => (
            <button
              key={p.id}
              onClick={() => pick(p)}
              className="profile-tile group text-center focus:outline-none relative"
            >
              <div
                className="w-36 h-36 md:w-44 md:h-44 rounded-2xl overflow-hidden relative ring-4 ring-transparent group-hover:ring-white group-focus:ring-white transition"
                style={{ boxShadow: `0 16px 40px -14px ${p.color}80` }}
              >
                <img src={p.avatar} alt={p.name} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                {p.is_kids && (
                  <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full text-[10px] font-bold tracking-widest bg-amber-500 text-black">KIDS</span>
                )}
              </div>
              <div className="mt-4 text-white/80 group-hover:text-white text-lg font-medium flex items-center justify-center gap-2">
                {p.name}
                {editing && (
                  <span
                    role="button"
                    onClick={(e) => { e.stopPropagation(); pick({ ...p, is_kids: !p.is_kids }); }}
                    className={`text-[10px] px-2 py-0.5 rounded-full ${p.is_kids ? 'bg-amber-500 text-black' : 'bg-white/10 text-white/70'}`}
                  >
                    {p.is_kids ? 'Kids ON' : 'Kids OFF'}
                  </span>
                )}
              </div>
            </button>
          ))}
          <button className="profile-tile text-center focus:outline-none" onClick={() => pick(profiles[0])}>
            <div className="w-36 h-36 md:w-44 md:h-44 rounded-2xl border-2 border-dashed border-white/20 flex items-center justify-center text-white/50 hover:text-white hover:border-white/60 transition">
              <Plus size={42} />
            </div>
            <div className="mt-4 text-white/55 text-lg">Add Profile</div>
          </button>
        </div>

        <div className="mt-10 flex items-center justify-center">
          <button onClick={() => setEditing((e) => !e)} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 border border-white/10 hover:bg-white/10 text-white/80 text-sm">
            {editing ? <Check size={14} /> : <Settings size={14} />} {editing ? 'Done' : 'Manage profiles'}
          </button>
        </div>

        <div className="mt-10 text-center text-white/40 text-sm">
          <span className="kbd">← →</span> navigate &nbsp;•  <span className="kbd">Enter</span> select
        </div>
      </div>
    </div>
  );
};

export default ProfileSelect;
